export function normalizeQuantity(value, rules = {}) {
  const min = Math.max(1, Math.trunc(Number(rules.min) || 1));
  const step = Math.max(1, Math.trunc(Number(rules.step) || 1));
  const rawMax = rules.max === '' || rules.max == null ? Infinity : Number(rules.max);
  const max = Number.isFinite(rawMax) && rawMax >= min ? min + Math.floor((rawMax - min) / step) * step : Infinity;
  const raw = value === '' || value == null ? min : Number(value);
  const aligned = Number.isFinite(raw) ? min + Math.floor((raw - min) / step) * step : min;
  return Math.min(max, Math.max(min, aligned));
}

if (typeof document !== 'undefined') {
  const root = document.body;
  const previewId = root.dataset.studioPreviewTheme;
  const mobilePreview = root.classList.contains('skr-mobile-preview');
  const previewWidth = Number(new URL(location.href).searchParams.get('studio_width'));
  const previewWidths = [320, 360, 390, 430, 768, 1024, 1440];
  if (previewId && mobilePreview && previewWidths.includes(previewWidth)) root.style.setProperty('--skr-preview-width', previewWidth + 'px');

  const decorateUrl = (href) => {
    const url = new URL(href, location.origin);
    if (url.origin !== location.origin) return href;
    const view = url.searchParams.get('view');
    if (mobilePreview && view?.startsWith('studio') && !view.startsWith('studio-mobile') && url.pathname === new URL(root.dataset.studioRoot, location.origin).pathname) {
      url.searchParams.set('view', view.replace('studio', 'studio-mobile'));
    }
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    if (mobilePreview && previewWidths.includes(previewWidth)) url.searchParams.set('studio_width', String(previewWidth));
    return url.pathname + url.search + url.hash;
  };
  const preservePreview = () => {
    if (previewId) history.replaceState(null, '', decorateUrl(location.href));
  };
  preservePreview();
  if (document.readyState !== 'complete') addEventListener('load', preservePreview, {once: true});

  const quantityRules = input => ({min: input.min, max: input.max, step: input.step});
  const updateQuantity = (input, value = input.value) => {
    const rules = quantityRules(input);
    input.value = String(normalizeQuantity(value, rules));
    const group = input.closest('.skr-quantity');
    if (!group) return;
    group.querySelectorAll('[data-quantity-step]').forEach(button => {
      const next = normalizeQuantity(Number(input.value) + Number(button.dataset.quantityStep) * (Number(input.step) || 1), rules);
      button.disabled = next === Number(input.value);
    });
  };

  const setGalleryImage = (gallery, source, alt) => {
    const image = gallery?.querySelector('[data-main-image]');
    if (!image || !source) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = source;
    image.alt = alt || image.alt;
  };

  const updateVariant = (select, changeUrl = false) => {
    const option = select.selectedOptions[0];
    const form = select.closest('form');
    const info = select.closest('.skr-product-info');
    if (!option || !form || !info) return;
    const available = option.dataset.available === 'true';
    info.querySelector('[data-product-price]').textContent = option.dataset.price;
    const compare = info.querySelector('[data-compare-price]');
    if (compare) {compare.textContent = option.dataset.comparePrice || ''; compare.hidden = !option.dataset.comparePrice;}
    const button = form.querySelector('[data-product-submit]');
    button.disabled = !available || form.dataset.studioRequiresArtwork === 'true';
    button.querySelector('span').textContent = available ? button.dataset.availableText : button.dataset.soldText;
    const input = form.elements.quantity;
    input.min = option.dataset.min || '1';
    input.step = option.dataset.step || '1';
    if (option.dataset.max) input.max = option.dataset.max; else input.removeAttribute('max');
    updateQuantity(input);
    if (changeUrl) {
      const page = select.closest('[data-studio-product]');
      const gallery = page.querySelector('.skr-gallery');
      setGalleryImage(gallery, option.dataset.image || page.dataset.defaultImage, option.dataset.imageAlt || page.dataset.productTitle);
      gallery?.querySelectorAll('[data-gallery-image]').forEach(thumb => {
        const active = thumb.dataset.galleryImage === (option.dataset.image || page.dataset.defaultImage);
        thumb.setAttribute('aria-pressed', String(active));
        thumb.classList.toggle('is-active', active);
      });
      const url = new URL(location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    }
  };

  const updateCategories = () => {
    const categories = root.querySelector('[data-demo-categories]');
    const grid = root.querySelector('[data-demo-grid]');
    if (!categories || !grid) return;
    const aliases = {tshirts: 'tshirt', hoodies: 'hoodie', tassen: 'tote', dtf: 'dtf', borduren: 'embroidery'};
    const category = aliases[location.hash.slice(1)] || 'all';
    let count = 0;
    grid.querySelectorAll('[data-demo-kind]').forEach(card => {
      card.hidden = category !== 'all' && card.dataset.demoKind !== category;
      if (!card.hidden) count++;
    });
    categories.querySelectorAll('[data-category]').forEach(link => {
      const active = link.dataset.category === category;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
    });
    const status = root.querySelector('[data-demo-count]');
    if (status) status.textContent = count + ' ' + (count === 1 ? categories.dataset.countSingular : categories.dataset.countLabel);
  };

  const initialize = (scope) => {
    scope.querySelectorAll('[data-studio-link],.skr-pagination a').forEach(link => link.href = decorateUrl(link.getAttribute('href')));
    scope.querySelectorAll('[data-studio-variant]').forEach(select => updateVariant(select));
    scope.querySelectorAll('.skr-quantity input').forEach(input => updateQuantity(input));
    scope.querySelectorAll('.skr-filter-form,.skr-search-form').forEach(form => {
      if (!previewId || form.querySelector('[name="preview_theme_id"]')) return;
      const field = document.createElement('input');
      field.type = 'hidden'; field.name = 'preview_theme_id'; field.value = previewId; form.append(field);
    });
    updateCategories();
  };

  root.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const opener = target.closest('[data-open-dialog]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.openDialog);
      if (dialog && !dialog.open) {
        dialog.showModal();
        root.querySelectorAll('[aria-controls="' + dialog.id + '"]').forEach(control => control.setAttribute('aria-expanded', 'true'));
      }
      return;
    }
    const close = target.closest('[data-close-dialog]');
    if (close) {close.closest('dialog')?.close(); return;}
    if (target instanceof HTMLDialogElement) {
      const rect = target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) target.close();
    }
    const step = target.closest('[data-quantity-step]');
    if (step) {
      const input = step.closest('.skr-quantity').querySelector('input');
      updateQuantity(input, normalizeQuantity(input.value, quantityRules(input)) + Number(step.dataset.quantityStep) * (Number(input.step) || 1));
      return;
    }
    const thumb = target.closest('[data-gallery-image]');
    if (thumb) {
      const gallery = thumb.closest('.skr-gallery');
      setGalleryImage(gallery, thumb.dataset.galleryImage, thumb.dataset.galleryAlt);
      gallery.querySelectorAll('[data-gallery-image]').forEach(item => {item.classList.toggle('is-active', item === thumb); item.setAttribute('aria-pressed', String(item === thumb));});
    }
    const menuLink = target.closest('.skr-menu-dialog a');
    if (menuLink) menuLink.closest('dialog').close();
  });
  root.addEventListener('change', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.matches('[data-studio-variant]')) updateVariant(target, true);
    if (target.matches('.skr-quantity input')) updateQuantity(target);

  });
  root.addEventListener('close', event => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    root.querySelectorAll('[aria-controls="' + event.target.id + '"]').forEach(control => control.setAttribute('aria-expanded', 'false'));
  }, true);
  addEventListener('hashchange', updateCategories);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  initialize(root);

  const demo = root.querySelector('[data-demo-kind-current]');
  const legacyKind = location.hash.slice(1);
  if (demo && ['tshirt', 'hoodie', 'tote'].includes(legacyKind) && legacyKind !== demo.dataset.demoKindCurrent) {
    const destination = demo.querySelector('[data-demo-choice="' + legacyKind + '"]');
    if (destination) location.replace(decorateUrl(destination.href));
  }
}
